var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isProduct)?_c('LayoutHeader'):_vm._e(),(_vm.isProduct)?_c('div',{staticClass:"content"},[_c('router-view')],1):_vm._e(),(_vm.isProduct)?_c('LayoutFooter',{attrs:{"info":_vm.sidebarInfo}}):_vm._e(),(_vm.sidebarInfo.isOpen===1)?_c('Sidebar',{attrs:{"info":_vm.sidebarInfo}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }